/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OfferRequestPassengersInner } from './OfferRequestPassengersInner';
import {
    OfferRequestPassengersInnerFromJSON,
    OfferRequestPassengersInnerFromJSONTyped,
    OfferRequestPassengersInnerToJSON,
} from './OfferRequestPassengersInner';
import type { OfferRequestSlice } from './OfferRequestSlice';
import {
    OfferRequestSliceFromJSON,
    OfferRequestSliceFromJSONTyped,
    OfferRequestSliceToJSON,
} from './OfferRequestSlice';
import type { OfferIndex } from './OfferIndex';
import {
    OfferIndexFromJSON,
    OfferIndexFromJSONTyped,
    OfferIndexToJSON,
} from './OfferIndex';

/**
 * 
 * @export
 * @interface OfferRequest
 */
export interface OfferRequest {
    /**
     * The cabin that the passengers want to travel in
     * @type {string}
     * @memberof OfferRequest
     */
    cabinClass?: OfferRequestCabinClassEnum;
    /**
     * A client key to allow the Duffel Ancillaries component to talk to the Duffel API to retrieve information about an offer and its ancillaries. Learn more about how to use this on https://duffel.com/docs/guides/ancillaries-component.
     * @type {string}
     * @memberof OfferRequest
     */
    clientKey?: string;
    /**
     * The [ISO 8601](https://en.wikipedia.org/wiki/ISO_8601) datetime at which the offer request was created
     * @type {Date}
     * @memberof OfferRequest
     */
    createdAt?: Date;
    /**
     * Duffel's unique identifier for the resource
     * @type {string}
     * @memberof OfferRequest
     */
    id?: string;
    /**
     * Whether the offer request was created in live mode. This field will be set to `true` if the offer request was created in live mode, or `false` if it was created in test mode.
     * @type {boolean}
     * @memberof OfferRequest
     */
    liveMode?: boolean;
    /**
     * The offers returned by the airlines
     * @type {Array<OfferIndex>}
     * @memberof OfferRequest
     */
    offers?: Array<OfferIndex>;
    /**
     * The passengers who want to travel
     * @type {Array<OfferRequestPassengersInner>}
     * @memberof OfferRequest
     */
    passengers?: Array<OfferRequestPassengersInner>;
    /**
     * The [slices](/docs/api/overview/key-principles) that make up this offer request. One-way journeys can be expressed using one slice, whereas return trips will need two.
     * @type {Array<OfferRequestSlice>}
     * @memberof OfferRequest
     */
    slices?: Array<OfferRequestSlice>;
}


/**
 * @export
 */
export const OfferRequestCabinClassEnum = {
    First: 'first',
    Business: 'business',
    PremiumEconomy: 'premium_economy',
    Economy: 'economy'
} as const;
export type OfferRequestCabinClassEnum = typeof OfferRequestCabinClassEnum[keyof typeof OfferRequestCabinClassEnum];


/**
 * Check if a given object implements the OfferRequest interface.
 */
export function instanceOfOfferRequest(value: object): value is OfferRequest {
    return true;
}

export function OfferRequestFromJSON(json: any): OfferRequest {
    return OfferRequestFromJSONTyped(json, false);
}

export function OfferRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): OfferRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'cabinClass': json['cabin_class'] == null ? undefined : json['cabin_class'],
        'clientKey': json['client_key'] == null ? undefined : json['client_key'],
        'createdAt': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'id': json['id'] == null ? undefined : json['id'],
        'liveMode': json['live_mode'] == null ? undefined : json['live_mode'],
        'offers': json['offers'] == null ? undefined : ((json['offers'] as Array<any>).map(OfferIndexFromJSON)),
        'passengers': json['passengers'] == null ? undefined : ((json['passengers'] as Array<any>).map(OfferRequestPassengersInnerFromJSON)),
        'slices': json['slices'] == null ? undefined : ((json['slices'] as Array<any>).map(OfferRequestSliceFromJSON)),
    };
}

export function OfferRequestToJSON(value?: OfferRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'cabin_class': value['cabinClass'],
        'client_key': value['clientKey'],
        'created_at': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'id': value['id'],
        'live_mode': value['liveMode'],
        'offers': value['offers'] == null ? undefined : ((value['offers'] as Array<any>).map(OfferIndexToJSON)),
        'passengers': value['passengers'] == null ? undefined : ((value['passengers'] as Array<any>).map(OfferRequestPassengersInnerToJSON)),
        'slices': value['slices'] == null ? undefined : ((value['slices'] as Array<any>).map(OfferRequestSliceToJSON)),
    };
}

